import { render } from "./NftWrapper.vue?vue&type=template&id=6588879c&scoped=true"
import script from "./NftWrapper.vue?vue&type=script&lang=js"
export * from "./NftWrapper.vue?vue&type=script&lang=js"

import "./NftWrapper.vue?vue&type=style&index=0&id=6588879c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6588879c"]])

export default __exports__